module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('span', {
    staticClass: "titulo-especial"
  }, [_vm._v(_vm._s(_vm.valor))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52d3b592!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/RelatorioTitulo.vue
// module id = 1961
// module chunks = 1